import { type TeamTargetResponse } from '@on3/api';
import { PlayerInterestsHeader } from 'components/Db/Profile/PlayerInterests/PlayerInterestsHeader';
import { PlayerInterestsItem } from 'components/Db/Profile/PlayerInterests/PlayerInterestsItem';
import { MockDataBar } from 'components/Mock/MockDataBar';
import { AthleteType } from 'utils/player';

import styles from './TopInterestsMock.module.scss';

interface ITopInterestsMockProps {
  interests?: TeamTargetResponse[] | [];
}

export const TopInterestsMock = ({ interests }: ITopInterestsMockProps) => {
  const listLength = interests?.length || 0;

  const playerType = AthleteType.Base;
  const mockCount = Math.max(0, 5 - listLength);
  const positionAbbreviation = interests?.[0]?.positionAbbreviation ?? 'pos';

  return (
    <div className={styles.block}>
      <div role="table">
        {listLength > 0 && (
          <PlayerInterestsHeader
            playerType={AthleteType.Base}
            positionAbbreviation={positionAbbreviation}
          />
        )}
        <ol>
          {interests?.map((team, index) => (
            <PlayerInterestsItem
              key={`interest-${index}`}
              playerType={playerType}
              {...team}
            />
          ))}
          {Array.from({ length: mockCount }).map((_, rank) => (
            <li className={styles.item} key={rank}>
              <span className={styles.rank}>{listLength + rank + 1}</span>
              <MockDataBar />
              <MockDataBar />
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};
